export default __webpack_public_path__ + "static/media/main-bar-group-lyte.214f6cdc.png";